module.exports = __webpack_public_path__ + "img/bos17.e2356050.webp";